import React from "react";
import { cn } from "../../../../lib/utils";
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../ui/Form";
import { Input } from "../../ui/Input";

const DoorDimensions = ({ methods, isOpen: { DoorDimensions } }) => {
    const { control,setValue,getValues } = methods;
    const configuration = getValues('configuration')
    return (
        <div
            className={cn(
                "section flex flex-col gap-4  overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: DoorDimensions.isOpen,
                }
            )}
        >
            <FormField
                control={control}
                name="width"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-gray-700">
                            Width
                            <span className="text-sm text-primary">(mm)</span>
                        </FormLabel>
                        <FormControl>
                            <Input
                                type="number"
                                icon
                                className="text-gray-700"
                                placeholder="Enter Door Width"
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e)
                                    console.log(e.target.value)
                                    if(configuration === 'none') {
                                        setValue('aperture_width', e.target.value)
                                    }
                                }}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="height"
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-gray-700">
                            Height
                            <span className="text-sm text-primary">(mm)</span>
                        </FormLabel>
                        <FormControl>
                            <Input
                                type="number"
                                icon
                                className="text-gray-700"
                                placeholder="Enter Door Height"
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e)
                                    console.log(e.target.value)
                                    if(configuration === 'none') {
                                        setValue('aperture_height', e.target.value)
                                    }
                                }}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />

        </div>
    );
};

export default DoorDimensions;
